import { UtcDate } from '@/helpers/date';

const failed = {
  valid: false,
  required: true,
};

export default {
  computesRequired: true,
  params: ['taxiUsedFor', 'dateOfBirth', 'dateOfInsuranceStart'],
  validate (value, { taxiUsedFor, dateOfBirth, dateOfInsuranceStart }) {
    if ([undefined, null, ''].includes(value)) return failed;

    const maxStartDate = new UtcDate().addDays(this.constants.DATE_OF_INSURANCE_START_MAX_DAYS);

    const birthDate = dateOfBirth ? new UtcDate(dateOfBirth) : null;
    const dateOfInsuranceStartDate = dateOfInsuranceStart ? new UtcDate(dateOfInsuranceStart) : null;

    const startDate = (dateOfInsuranceStartDate && dateOfInsuranceStartDate.isValid()) ? dateOfInsuranceStartDate : maxStartDate;
    const age = (birthDate && birthDate.isValid()) ? startDate.differenceInYears(birthDate) : null;

    if (age) {
      if (
        taxiUsedFor === 1 &&
        age >= this.constants.TAXI_MIN_AGES_BY_USE[1] &&
        (+value > (3 + age - this.constants.TAXI_MIN_AGES_BY_USE[1]))
      ) return failed;
      if (
        taxiUsedFor === 2 &&
        age >= this.constants.TAXI_MIN_AGES_BY_USE[2] &&
        (+value > (3 + age - this.constants.TAXI_MIN_AGES_BY_USE[2]))
      ) return failed;
    }

    return {
      valid: true,
      required: true,
    };
  },
  message (fieldName, { _value_: value }) {
    const defaultMsg = 'Please select how long you have held a taxi badge.';
    const ageMsg = 'Please check how long you\'ve held a taxi badge in relation to your age.';

    if ([undefined, null, ''].includes(value)) return defaultMsg;
    else return ageMsg;
  },
};
